import type { CSSProperties } from 'react';
import { breakpoints } from '@client/theme/constants';
import type { Theme } from '@mui/material/styles';

export const appBar = (theme: Theme): CSSProperties => ({
  height: theme.heights.DesktopAppBar,

  [breakpoints.down('md')]: {
    height: theme.heights.MobileAppBar,
  },
});

export const gutters = (theme: Theme): CSSProperties => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),

  [breakpoints.up('md')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
});
